var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIconLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 518 508",
    style: {
      enableBackground: "new 0 0 518 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill: #4B6E86;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross-sign_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    className: "st0",
    d: "M461.5,89.4l-29.4-29.1c-8.2-8-21.2-8-29.4,0L256,207.1L106.6,57.7c-8.2-8-21.2-8-29.4,0 L47.9,87.1c-8,8.2-8,21.2,0,29.4L197,265.6l-146.4,147c-8,8.2-8,21.2,0,29.4l29.4,29.4c8.2,8,21.2,8,29.4,0L256,324.5l146.8,146.8 c8.2,8,21.2,8,29.4,0l29.4-29.4c8-8.2,8-21.2,0-29.4L314.4,265.9l146.8-146.8C469.3,111,469.5,97.8,461.5,89.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconLink);
export default __webpack_public_path__ + "static/media/cross_icon_link.deacddf6.svg";
export { ForwardRef as ReactComponent };